export default {
  methods: {
    scrollToClass(className) {
      let el = document.getElementsByClassName(className)[0];
      var height = 0;
      let mainLobby = document.getElementById("ClientLobbyCard");
      if (mainLobby) {
        if (el) {
          // Get the bounding rectangle so we can get the element position position
          let rect = el.getBoundingClientRect();
          height = 0;
          mainLobby.scrollTo(rect.left, rect.y);
        }
      } else {
        let navbar = document.getElementById("navbar");
        if (el) {
          // Get the bounding rectangle so we can get the element position position
          let rect = el.getBoundingClientRect();
          if (navbar) height = navbar.clientHeight;
          else height = 0;
          // Scroll to the element (using x and y axis)
          window.scrollTo(rect.left, rect.top - height);
        }
      }
    }
  }
};
